import { checkboxAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

/**
 * Chakra-UI Radio has three sub-components: control, label, and container
 * This file customizes the default Radio theme.
 *
 * https://chakra-ui.com/docs/components/radio/theming
 */

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(checkboxAnatomy.keys);

const baseStyle = definePartsStyle({
  container: {
    _hover: {
      borderColor: "blue.500",
    },
  },
});

export const checkboxTheme = defineMultiStyleConfig({
  baseStyle,
  variants: {
    ellipsis: {
      container: {
        overflowX: "hidden",
      },
      label: {
        display: "block",
        whiteSpace: "nowrap",
        overflowX: "hidden",
        textOverflow: "ellipsis",
      },
    },
    opaque: {
      control: {
        bg: "white",
      },
    },
  },
});
